import { atom } from 'recoil';

type AclosetChatState = {
  totalUnreadChannelCount: number;
};

export const aclosetChatState = atom<AclosetChatState>({
  key: 'aclosetChatState',
  default: {
    totalUnreadChannelCount: 0,
  },
});
